import { createFileRoute, redirect } from "@tanstack/react-router";

// Đường cũ của màn Tiếng khách, giữ lại để không chết link.
//
// 25/09/2026 màn gộp thành THẺ đầu của trang Khiếu nại. Ai còn giữ dấu trang,
// còn link trong tin nhắn hay trong bài hướng dẫn cũ thì rơi thẳng về trang
// mới thay vì ăn trang 404 — và không ai phải đi sửa những chỗ đó.
export const Route = createFileRoute("/_app/customer-voice/")({
  beforeLoad: () => {
    throw redirect({ to: "/complaints", replace: true });
  },
});
